import PropTypes from 'prop-types';

// For old API response, not GraphQL
const lineItemPropTypes = PropTypes.shape({
    //
});

export default lineItemPropTypes;
